
export type ChatThreadCurrentUserStatusStatus = typeof ChatThreadCurrentUserStatusStatus[keyof typeof ChatThreadCurrentUserStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatThreadCurrentUserStatusStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  BLOCKED: 'BLOCKED',
} as const;
